import { processItemSummaryDocSchema } from '../../../shared/sync/processItemSummaries';
import { rxdbFromZod } from '../lib/rxdbFromZod';
import { type z } from 'zod/v4';

export type ProcessItemSummaryDoc = z.infer<typeof processItemSummaryDocSchema>;

export const processItemSummarySchema = rxdbFromZod(
  processItemSummaryDocSchema,
  {
    indexes: ['updatedAt'],
    primaryKey: 'processId',
    stringMaxLength: { processId: 36 },
    version: 0,
  },
);
